var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.083,
    height: 74.252,
    viewBox: "0 0 40.083 74.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-animated",
    transform: "translate(-8.342 68.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle_to",
    transform: "translate(8.342 -46.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle",
    d: "M39.2,17.2h6.68a.7.7,0,0,1,.706.706v6.479a.7.7,0,0,1-.706.706H39.2a.7.7,0,0,1-.706-.706V17.906A.689.689,0,0,1,39.2,17.2Z",
    transform: "translate(-38.495 -17.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-2_to",
    transform: "translate(8.342 -30.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-2",
    d: "M39.2,81.8h6.68a.7.7,0,0,1,.706.706v35.015a.7.7,0,0,1-.706.706H39.2a.7.7,0,0,1-.706-.706V82.531A.7.7,0,0,1,39.2,81.8Z",
    transform: "translate(-38.495 -81.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-3_to",
    transform: "translate(40.333 -46.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-3",
    d: "M166.106,17.2h6.68a.7.7,0,0,1,.706.706v8.445a.7.7,0,0,1-.706.706h-6.68a.7.7,0,0,1-.706-.706V17.906A.7.7,0,0,1,166.106,17.2Z",
    transform: "translate(-165.4 -17.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-4_to",
    transform: "translate(40.333 -28.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-4",
    d: "M166.106,89.7h6.68a.7.7,0,0,1,.706.706V101.22a.7.7,0,0,1-.706.706h-6.68a.7.7,0,0,1-.706-.706V90.406A.689.689,0,0,1,166.106,89.7Z",
    transform: "translate(-165.4 -89.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-5_to",
    transform: "translate(24.326 -46.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-5",
    d: "M102.606,17.2h6.68a.7.7,0,0,1,.706.706V32.779a.7.7,0,0,1-.706.706h-6.68a.7.7,0,0,1-.706-.706V17.906A.721.721,0,0,1,102.606,17.2Z",
    transform: "translate(-101.9 -17.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-rectangle-6_to",
    transform: "translate(24.326 -22.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-rectangle-6",
    d: "M102.606,114.7h6.68a.7.7,0,0,1,.706.706v10.512a.7.7,0,0,1-.706.706h-6.68a.7.7,0,0,1-.706-.706V115.406A.721.721,0,0,1,102.606,114.7Z",
    transform: "translate(-101.9 -114.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g1_to",
    transform: "translate(8.747 -68.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g1",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path1",
    d: "M40.1,168.432c0-2.445,1.286-3.832,3.63-3.832s3.63,1.386,3.63,3.832v7.916c0,2.445-1.286,3.832-3.63,3.832s-3.63-1.386-3.63-3.832Zm2.395,8.067c0,1.084.479,1.513,1.235,1.513s1.235-.4,1.235-1.513V168.28s-.479-1.513-1.235-1.513-1.235.4-1.235,1.513Z",
    transform: "translate(-40.1 -164.6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g2_to",
    transform: "translate(40.736 -68.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g2",
    transform: "translate(0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path2",
    d: "M167,5.832C167,3.386,168.286,2,170.63,2s3.63,1.386,3.63,3.832v7.916c0,2.445-1.286,3.832-3.63,3.832S167,16.192,167,13.747V5.832Zm2.395,8.067c0,1.084.479,1.513,1.235,1.513s1.235-.4,1.235-1.513V5.68c0-1.084-.479-1.513-1.235-1.513s-1.235.4-1.235,1.513Z",
    transform: "translate(-167 -2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g3_to",
    transform: "translate(24.754 -68.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g3",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path3",
    d: "M103.6,111.332c0-2.445,1.286-3.832,3.63-3.832s3.63,1.386,3.63,3.832v7.916c0,2.445-1.286,3.832-3.63,3.832s-3.63-1.386-3.63-3.832Zm2.37,8.067c0,1.084.479,1.513,1.235,1.513s1.235-.4,1.235-1.513V111.18c0-1.084-.479-1.513-1.235-1.513s-1.235.4-1.235,1.513Z",
    transform: "translate(-103.6 -107.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g4_to",
    transform: "translate(9.377 -67.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g4",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path4",
    d: "M42.6,85.716A2.346,2.346,0,0,0,45.222,83.8h1.613V99.026H44.44V87.4H42.6Z",
    transform: "translate(-42.6 -83.8)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g5_to",
    transform: "translate(25.662 -67.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g5",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path5",
    d: "M107.2,21.216a2.346,2.346,0,0,0,2.622-1.916h1.613V34.526H109.04V22.9H107.2Z",
    transform: "translate(-107.2 -19.3)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g6_to",
    transform: "translate(41.367 -67.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g6",
    transform: "translate(0 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path6",
    d: "M169.5,89.916A2.346,2.346,0,0,0,172.122,88h1.613v15.226H171.34V91.6H169.5Z",
    transform: "translate(-169.5 -88)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g7_to",
    transform: "translate(8.747 -68.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-faktor22-g7",
    transform: "translate(0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-faktor22-path7",
    d: "M40.1,5.832C40.1,3.386,41.386,2,43.73,2s3.63,1.386,3.63,3.832v7.916c0,2.445-1.286,3.832-3.63,3.832s-3.63-1.386-3.63-3.832V5.832ZM42.495,13.9c0,1.084.479,1.513,1.235,1.513s1.235-.4,1.235-1.513V5.68c0-1.084-.479-1.513-1.235-1.513s-1.235.4-1.235,1.513Z",
    transform: "translate(-40.1 -2)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b07dec91f0ad7cedaae1b4595c95970d.svg";
export { ForwardRef as ReactComponent };